/* Sisters Lemonade - /pour activation capture page.
 * Email capture -> HubSpot (email-only form; portal 245741422), attribution via ?e= or current-event metafield (sent to GA4),
 * post-submit intent chips + Google review ask, GA4 page_view(e)/generate_lead. No external libs. */
(function(){
  var form = document.getElementById('pour-form');
  if(!form) return;
  var card = form.closest('.slpp-card');
  var thanks = card.querySelector('.slpp-thanks');
  var errEl = form.querySelector('.slpp-err');
  var EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
  var portal = form.getAttribute('data-hs-portal');
  var guid = form.getAttribute('data-hs-form');
  var STUB = /PLACEHOLDER/.test(guid);
  var endpoint = 'https://api.hsforms.com/submissions/v3/integration/submit/' + portal + '/' + guid;

  // Attribution: ?e= wins, else the current-event metafield slug (already in the hidden field).
  var params = new URLSearchParams(location.search);
  var eParam = params.get('e');
  var slugEl = form.querySelector('[name="event_slug"]');
  if(eParam){ slugEl.value = eParam; }
  var slug = slugEl.value || '';

  function ga(name, extra){
    if(typeof window.gtag === 'function'){
      var d = { event_slug: slug }; if(extra){ for(var k in extra){ d[k]=extra[k]; } }
      window.gtag('event', name, d);
    }
  }
  // GA4 page_view carrying the e param (auto page_view still fires; this tags the activation).
  ga('page_view', { page_location: location.href });

  function cookie(n){ var m = document.cookie.match('(^|;)\\s*' + n + '\\s*=\\s*([^;]+)'); return m ? m.pop() : ''; }

  function submitHubspot(fields){
    if(STUB){ return Promise.resolve(); } // no live form yet — thank-you still shows for preview
    var ctx = { pageUri: location.href, pageName: document.title };
    var hutk = cookie('hubspotutk'); if(hutk){ ctx.hutk = hutk; }
    return fetch(endpoint, {
      method:'POST', headers:{'Content-Type':'application/json'},
      body: JSON.stringify({ fields: fields, context: ctx })
    }).then(function(r){ if(!r.ok){ throw new Error('HTTP ' + r.status); } return r.json(); });
  }

  form.addEventListener('submit', function(e){
    e.preventDefault();
    errEl.hidden = true;
    var email = (form.querySelector('[name="email"]').value || '').trim();
    if(!EMAIL_RE.test(email)){ errEl.textContent = 'Please enter a valid email address.'; errEl.hidden = false; return; }
    var btn = form.querySelector('[type="submit"]');
    var label = btn.textContent; btn.disabled = true; btn.textContent = 'Sending…';
    form.querySelector('[name="timestamp"]').value = new Date().toISOString();

    // Email-only form: HubSpot rejects the whole submission if we send fields the form
    // doesn't define, so only email goes to HubSpot. Attribution (event_slug/building/intent)
    // rides on GA4 below. Re-add these once matching HubSpot contact properties exist.
    var fields = [
      { name:'email', value: email }
    ];

    submitHubspot(fields).then(function(){
      ga('generate_lead', { currency:'USD', value: 0 });
      form.hidden = true;
      thanks.hidden = false;
      var re = card.querySelector('#pour-review');
      var note = card.querySelector('.slpp-review .note');
      if(/PLACEHOLDER/.test(re.getAttribute('href'))){ re.removeAttribute('href'); re.setAttribute('disabled',''); note.hidden = false; }
      thanks.scrollIntoView({ behavior:'smooth', block:'start' });
    }).catch(function(){
      btn.disabled = false; btn.textContent = label;
      errEl.textContent = 'Sorry, something went wrong. Please try again in a moment.';
      errEl.hidden = false;
    });
  });

  // Intent chips (post-submit, optional). Updates the UI + GA4; no HubSpot property yet.
  var chips = card.querySelectorAll('.slpp-chip');
  Array.prototype.forEach.call(chips, function(chip){
    chip.addEventListener('click', function(){
      var intent = chip.getAttribute('data-intent');
      Array.prototype.forEach.call(chips, function(c){ c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
      form.querySelector('[name="intent"]').value = intent;
      if(intent === 'event'){ var rev = card.querySelector('.slpp-reveal'); if(rev){ rev.hidden = false; } }
      // Intent goes to GA4 only for now (no HubSpot 'intent' property yet).
      ga('select_content', { content_type:'intent', item_id: intent });
    });
  });
})();
